import type { ReactNode } from 'react';
import { AlertTriangle, CheckCircle2, Info, XCircle } from 'lucide-react';
import { cn } from '@/utils/cn';

type Tone = 'info' | 'success' | 'warning' | 'error';

const TONES: Record<Tone, { wrapper: string; Icon: typeof Info }> = {
  info: { wrapper: 'bg-brand-50 text-brand-800 border-brand-200', Icon: Info },
  success: { wrapper: 'bg-emerald-50 text-emerald-800 border-emerald-200', Icon: CheckCircle2 },
  warning: { wrapper: 'bg-amber-50 text-amber-900 border-amber-200', Icon: AlertTriangle },
  error: { wrapper: 'bg-red-50 text-red-800 border-red-200', Icon: XCircle },
};

export function Alert({
  tone = 'info',
  children,
  className,
}: {
  tone?: Tone;
  children: ReactNode;
  className?: string;
}) {
  const { wrapper, Icon } = TONES[tone];

  return (
    <div
      role={tone === 'error' ? 'alert' : 'status'}
      className={cn(
        'flex items-start gap-3 rounded-lg border px-4 py-3 text-sm',
        wrapper,
        className,
      )}
    >
      <Icon className="mt-0.5 size-4 shrink-0" aria-hidden />
      <div className="flex-1">{children}</div>
    </div>
  );
}
